/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import {useSelectErrorMessageList, useSelectFileUploadResponse} from "../../../../redux/ducks/Wizard/SliceProvider";
import Plotly2DTracesTop from "../Plots/Plotly2DTracesTop";
import TemplateStep from "../../../components/Wizard/Steps/TemplateStep";
import {IBaseStepProps} from "../../../components/Wizard/types";

const Step2DTracesTop = (props: IBaseStepProps) => {
  const {messagesTitle} = props
  const response = useSelectFileUploadResponse()
  const plotlyTraces = response?.cosmos_data?.sensors_data_map
  const dimensionsList = response?.cosmos_data?.metadata?.dimensions_list
  const messages = useSelectErrorMessageList(2)

  const content2 = (
    <div>
      <Plotly2DTracesTop plotlyTraces={plotlyTraces} dimensionsList={dimensionsList}/>
    </div>
  )
  return (
    <>
      <TemplateStep content1={null} content2={content2} errorMessages={messages}
                    messagesTitle={messagesTitle} isFirstWizardStep={false} isLastWizardStep={false}
                    customTopRow={null}
      />
    </>
  );
};

export default Step2DTracesTop